import * as types from "./ActionTypes";
import InitialState from "Store/InitialState";
import produce from "immer";
// import { store, persistor } from "../index";
import httpService from "services/httpService";
import log from "loglevel";


// const getForum = (state, action) => {
//   //log.log("Action.payload.data.tags",action.payload.data.tags);
//   return produce(state, (draftState) => {
//     draftState.tags = action.payload.data.tags;
//   });
// };

export function forumReducer(state = InitialState.forum, action) {
  let comments = {};
  let commentsNext = {};
  let result;
  // let comment = {};
  // let threadList = [];
  // let threadId;
  // let commentId;
  // let replyId;
  let threads = {};
  let replies = {};
  let repliesNext = {};
  let new_threadList = [];
  let pinnedJustNow = 0;

  switch (action.type) {
    case types.GET_FORUM:
      log.log("Action.payload.data.tags", action.payload.data.tags);
      let rawTags = action.payload.data.tags;
      const GROUP_BY_KEY = 'groupBy';
      let processedTags = rawTags?.map(t => {
        let title = t.title;
        if (title) {
          if (title.includes("|")) {
            title = title.split(" | ");
            t[GROUP_BY_KEY] = title[0];
            t[GROUP_BY_KEY + "Title"] = title[1];
          } else {
            t[GROUP_BY_KEY] = title;
            t[GROUP_BY_KEY + "Title"] = title;
          }
        } else {
          t[GROUP_BY_KEY] = "Others"
        }
        return t;
      })
      return produce(state, (draftState) => {
        log.log({draftState: action.payload, state})
        draftState.tags = processedTags || [];
      });

    case types.LOAD_ALL_THREADS_REQUEST:
      if (action.data === 1 || action.data === "1")
        return { loading: true, tags: (state?.tags || []) }
      else
        return { ...state, loading: true };

    case types.LOAD_ALL_THREADS_FAILED:
      return {...state, loading: false, error: true}

    case types.LOAD_ALL_THREADS:
      // log.log("filtered thread", action.payload.data.results)
      log.log({ threads, l: state.threads });
      if (state.threads) {
        threads = JSON.parse(JSON.stringify(state.threads));
      }
      log.log({ threads, l: state.threads });
      for (result in action.payload.data.results) {
        threads[action.payload.data.results[result].id] =
          action.payload.data.results[result];
      }
      // return produce(state, (draftState) => {
      // draftState.threads=threads
      // draftState.threadList=action.payload.data.results
      // draftState.count=action.payload.data.count
      // draftState.next=action.payload.data.next
      // draftState.previous=action.payload.data.previous
      // });
      let nextPageNumber = null;
      if (action.payload.data.next && action.payload.data.next.includes("page=")) {
        nextPageNumber = action.payload.data.next.split("page=")[1];
      }

      let newThreadList = [];

      if (action.payload.data.count === 0) {
        // no threads for a concept id
      } else if (action.payload.data.results && state.threadList) {
        if (action.payload.data.count < state.count) { // when we have just applied filters (for Topic Related DF)
          newThreadList = [...action.payload.data.results];
        } else {
          newThreadList = [...state.threadList, ...action.payload.data.results];
        }

        // remove duplicates
        let uniqueElements = [];
        let wasInserted = [];
        newThreadList.forEach(t => {
          if (!wasInserted[t.id]) {
            uniqueElements.push(t);
            wasInserted[t.id] = true;
          }
        });
        newThreadList = uniqueElements;
      } else {
        newThreadList = action.payload.data.results;
      }
      let state_to_update = {
        ...state,
        threads: threads,
        threadList: newThreadList,
        count: action.payload.data.count,
        next: action.payload.data.next,
        previous: action.payload.data.previous,
        nextPageNumber: nextPageNumber,
        loading: false,
        courseId: Number(action.payload.courseId) // Store courseId for deduplication
      }
      if (httpService.pendingThreadRequests.length === 0) {
        state_to_update['onscroll_loading'] = 'false';
      }
      return state_to_update;

    case types.LOAD_ALL_THREADS_BY_ORDER:
      //log.log("filtered thread", action.payload.data.results)
      log.log({ threads, l: state.threads });
      if (state.threads) {
        threads = JSON.parse(JSON.stringify(state.threads));
      }
      log.log({ threads, l: state.threads });
      for (result in action.payload.data.results) {
        threads[action.payload.data.results[result].id] =
          action.payload.data.results[result];
      }

      let nextPageNumber_ = null;
      if (action.payload.data.next && action.payload.data.next.includes("page=")) {
        nextPageNumber_ = action.payload.data.next.split("page=")[1];
      }

      log.log({ forumReducer: [action.payload.data.results, state.threadList, nextPageNumber_] })
      let newThreadList_ = [];
      if (action.payload.data.count === 0) {
        // no threads for a concept id
      } else if (action.payload.data.results && state.threadList && nextPageNumber_ !== "2" && nextPageNumber_) {
        if (action.payload.data.count < state.count) { // when we have just applied filters (for Topic Related DF)
          newThreadList_ = [...action.payload.data.results];
        } else {
          newThreadList_ = [...state.threadList, ...action.payload.data.results];
        }
        // remove duplicates
        let uniqueElements = [];
        let wasInserted = [];
        newThreadList_.forEach(t => {
          if (!wasInserted[t.id]) {
            uniqueElements.push(t);
            wasInserted[t.id] = true;
          }
        });
        newThreadList_ = uniqueElements;
      } else {
        newThreadList_ = action.payload.data.results;
      }

      return {
        ...state,
        threads: threads,
        threadList: newThreadList_,
        count: action.payload.data.count,
        next: action.payload.data.next,
        previous: action.payload.data.previous,
        nextPageNumber: nextPageNumber_,
        currentOrder: action.payload.order,
        loading: false,
        courseId: Number(action.payload.courseId) // Store courseId for deduplication
      };

    case types.ADD_THREAD:
      //log.log("Add-THREAD-redux", action.payload.data)
      return {
        ...state,
        threadList: [action.payload.data, ...state.threadList],
        comments: {
          [action.payload.data.id]: {},
        },
        count: state.count + 1
      };

    case types.GET_COMMENT:
      if (state.comments) {
        comments = JSON.parse(JSON.stringify(state.comments));
      } else {
        comments = {};
      }
      log.log("comment Data", action.payload);
      commentsNext[action.payload.threadId] = {
        next: action.payload.data.next,
        count: action.payload.data.count,
        previous: action.payload.data.previous
      }
      if (action.payload.data.next && action.payload.data.next.includes("page=")) {
        let temp = action.payload.data.next;
        let nextPageNumber = temp.split('page=')[1];
        commentsNext[action.payload.threadId].nextPageNumber = nextPageNumber;
      }
      let state_ = JSON.parse(JSON.stringify(state));
      comments[action.payload.threadId] = {};
      if (state_.comments && state_.comments[action.payload.threadId]) {
        comments[action.payload.threadId] = state_.comments[action.payload.threadId]
      }
      for (result in action.payload.data.results) {
        // let commentId=action.payload.data.results[result].id
        log.log(action.payload.threadId, action.payload.data.results[result].id, comments, action.payload.data.results[result], result);
        comments[action.payload.threadId][action.payload.data.results[result].id] = action.payload.data.results[result];
      }

      // comments[action.payload.threadId].comment=comment
      state_.comments = { ...state.comments, ...comments };
      state_.commentsNext = { ...state_.commentsNext, ...commentsNext };
      log.log("state is ===================================== ", state_);
      return state_;

    // case types.LOAD_ALL_THREADS_BY_ORDER: {
    //   let { data } = action.payload;
    //   for (result in action.payload.data.results) {
    //     threads[action.payload.data.results[result].id] =
    //       action.payload.data.results[result];
    //   }

    //   return produce(state, (draftState) => {
    //     draftState.threadList = data.results;
    //     draftState.count = data.count;
    //     draftState.next = data.next;
    //   });
    // }

    case types.EDIT_THREAD:
      new_threadList = state.threadList.map((item, index) => {
        // Find the item with the matching id
        if (item.id === action.payload.data.id) {
          // Return a new object
          return action.payload.data;
        }
        return item;
      });

      return {
        ...state,
        threadList: new_threadList,
      };

    case types.CHANGE_THREAD_TAGS:
      new_threadList = state.threadList.map((item, index) => {
        // log.log(action.payload.threadId)
        // Find the item with the matching id
        if (item.id === action.payload.threadId) {
          // Return a new object
          return { ...item, tags: action.payload.data };
        }
        return item;
      });

      return {
        ...state,
        threadList: new_threadList,
      };

    case types.ADD_COMMENT: {
      let threadComments = { ...state.comments[action.payload.threadId] };
      comments = { ...state.comments };
      threadComments[action.payload.data.id] = action.payload.data;
      comments[action.payload.threadId] = threadComments;
      //log.log("Add-comment-redux", action.payload.data,state)
      return produce(state, (draftState) => {
        draftState.comments = comments;
        // Update children_count in threadList
        const threadIndex = draftState.threadList.findIndex(
          (t) => t.id === action.payload.threadId
        );
        if (threadIndex !== -1) {
          draftState.threadList[threadIndex].children_count += 1;
        }
        // Update children_count in threads object
        if (draftState.threads && draftState.threads[action.payload.threadId]) {
          draftState.threads[action.payload.threadId].children_count += 1;
        }
      });
    }

    case types.EDIT_COMMENT:
      log.log("In reducer.js EDIT_COMMENT", action.payload);
      return produce(state, (draftState) => {
        draftState.comments[action.payload.threadId][action.payload.commentId] =
        {
          ...state.comments[action.payload.threadId][
          action.payload.commentId
          ],
          ...action.payload.data,
        };
      });

    case types.ADD_REPLY:
      log.log("In reducer.js, ADD_REPLY");

      // return produce(state, (draftState) => {
      //   draftState.comments[action.payload.threadId][action.payload.commentId] = action.payload.data;
      //   draftState.replies[action.payload.commentId] = action.payload.data.replies;
      // });

      let threadReplies = { ...state.replies[action.payload.commentId] };
      replies = { ...state.replies };
      threadReplies[action.payload.data.id] = action.payload.data.replies;
      replies[action.payload.commentId] = threadReplies;
      //log.log("Add-comment-redux", action.payload.data,state)
      return produce(state, (draftState) => {
        draftState.replies = replies;
      });

      
    case types.EDIT_REPLY:
      log.log("In reducer.js EDIT_REPLY", action.payload);
      return produce(state, (draftState) => {
        // draftState.replies[action.payloo]
        draftState.replies[action.payload.commentId][action.payload.replyId] = { ...state.replies[action.payload.commentId][action.payload.replyId], ...action.payload.data };
      });

    case types.DELETE_THREAD:
      //log.log("deleting Thread")
      return {
        ...state,
        threadList: state.threadList.filter(
          (item) => item.id !== action.payload.threadId
        ),
        count: state.count - 1
      };

    // dbg
    case types.DELETE_COMMENT:
      const threadId = action.payload.threadId;
      const commentIdToDelete = action.payload.commentId;

      const updatedThreadComments = Object.fromEntries(
        Object.entries(state.comments[threadId]).filter(
          ([key]) => key !== commentIdToDelete
        )
      );

      // Update children_count in threadList
      const updatedThreadList = state.threadList.map((t) => {
        if (t.id === threadId) {
          return { ...t, children_count: Math.max(0, t.children_count - 1) };
        }
        return t;
      });

      // Update children_count in threads object
      const updatedThreads = { ...state.threads };
      if (updatedThreads[threadId]) {
        updatedThreads[threadId] = {
          ...updatedThreads[threadId],
          children_count: Math.max(0, updatedThreads[threadId].children_count - 1)
        };
      }

      return {
        ...state,
        comments: {
          ...state.comments,
          [threadId]: updatedThreadComments
        },
        threadList: updatedThreadList,
        threads: updatedThreads
      };

    // dbg
    case types.DELETE_REPLY:
      const commentId = action.payload.commentId;
      const replyId = action.payload.replyId;

      const updatedThreadReplies = Object.fromEntries(
        Object.entries(state.replies[commentId]).filter(
          ([key]) => key !== replyId
        )
      );

      return {
        ...state,
        replies: {
          ...state.replies,
          [commentId]: updatedThreadReplies
        }
      };
      

    case types.PIN_THREAD_CONTENT:
      //log.log("Old threadList", action.payload.threadId, state.threadList)
      new_threadList = state.threadList.map((item, index) => {
        // Find the item with the matching id
        if (item.id === action.payload.data.id) {
          // Return a new object
          return {
            ...item, // copy the existing item
            pinned: action.payload.data.pinned, // replace the email addr
          };
        }
        return item;
      });

      //log.log("new threadList", new_threadList)
      let new_threadList_to_save = customSortThreads(new_threadList, state.currentOrder);

      return {
        ...state,
        pinnedJustNow: pinnedJustNow + 1,
        threadList: new_threadList_to_save
      };

    case types.MARK_IMPORTANT:
      new_threadList = state.threadList.map((item, index) => {
        // Find the item with the matching id
        if (item.id === action.payload.data.id) {
          // Return a new object
          return {
            ...item, // copy the existing item
            importance: action.payload.data.importance, // replace the importance
          };
        }
        return item;
      });
      //log.log("new threadList", new_threadList)
      return {
        ...state,
        threadList: new_threadList,
      };

    case types.UPVOTE_THREAD:
      return produce(state, (draftState) => {
        // draftState.threadList[action.payload.data.id] = action.payload.data;
        draftState.threadList = state.threadList.map((item) => {
          if (item.id == action.payload.data.id) {
            return action.payload.data;
          }
          return item;
        });
        draftState.threads[action.payload.data.id] = action.payload.data;
      });

    case types.UPVOTE_COMMENT:
      let tid = action.payload.threadId;
      let cid = action.payload.commentId;
      log.log(tid, cid);
      log.log("threadId is", action.payload);
      return produce(state, (draftState) => {
        draftState.comments[tid][cid] = action.payload.data;
      });
    // return {
    //     ...state,
    //     comments: {
    //         ...state.comments,
    //         threadId: {
    //             ...state.comments[threadId],
    //             commentId: action.payload.data
    //         }
    //     }
    // }

    case types.LOAD_ALL_REPLIES:
      log.log("IN REDUCRE.JS, GET ALL REPLIES", action.payload.data)
      if (state.replies) {
        replies = JSON.parse(JSON.stringify(state.replies));
      } else {
        replies = {};
      }
      log.log("replies Data", action.payload);
      repliesNext[action.payload.commentId] = {
        next: action.payload.data.next,
        count: action.payload.data.count,
        previous: action.payload.data.previous
      }
      if (action.payload.data.next && action.payload.data.next.includes("page=")) {
        let temp = action.payload.data.next;
        let nextPageNumber = temp.split('page=')[1];
        repliesNext[action.payload.commentId].nextPageNumber = nextPageNumber;
      }
      let _state = JSON.parse(JSON.stringify(state));
      replies[action.payload.commentId] = {};
      if (_state.replies && _state.replies[action.payload.commentId]) {
        replies[action.payload.commentId] = _state.replies[action.payload.commentId]
      }
      for (result in action.payload.data.results) {
        // let commentId=action.payload.data.results[result].id
        replies[action.payload.commentId][action.payload.data.results[result].id] = action.payload.data.results[result];
      }
      _state.replies = { ...state.replies, ...replies };
      log.log(_state.replies);
      if (Array.isArray(_state.replies[action.payload.commentId])) {
        let uniqueReplies = [];
        _state.replies[action.payload.commentId].forEach((a, i) => {
          let find = uniqueReplies.findIndex(b => b.id === a.id);
          if (find === -1) {
            uniqueReplies.push(a);
          }
        });
        _state.replies[action.payload.commentId] = uniqueReplies;
      }

      _state.repliesNext = { ..._state.repliesNext, ...repliesNext };
      log.log("state is ===================================== ", _state);
      // return produce(state, (draftState) => {
      //   draftState.replies = replies;
      // });

      return _state;

    case types.UPVOTE_REPLY:
      log.log(action.payload);
      // state = {...state}
      // replies = {...state.replies}
      // log.log("upvoted data", action.payload)
      // replyId = action.payload.replyId;
      // const {commentId, replyId, data} = action.payload;
      //log.log("replyId and commentId are", replyId,commentId)
      //log.log("replies are ", replies)
      return produce(state, (draftState) => {
        draftState.replies[action.payload.commentId][action.payload.replyId] =
          action.payload.data;
      });

    case types.PIN_COMMENT_CONTENT:
      return produce(state, (draftState) => {
        draftState.comments[action.payload.threadId][
          action.payload.commentId
        ].pinned = action.payload.data.pinned;
      });

    case types.PIN_REPLY_CONTENT:
      log.log(action.payload);
      return produce(state, (draftState) => {
        draftState.replies[action.payload.commentId][
          action.payload.replyId
        ].pinned = action.payload.data.pinned;
      });
    
      default: {
        log.log(action);
      }
  }

  return state;
}

function customSortThreads(array, order) {
  switch (order) {
    case 'earlier':
      array.sort((a, b) => b.pinned - a.pinned || Date.parse(a.created) - Date.parse(b.created));
      break;
    case 'popularity':
      array.sort((a, b) => b.pinned - a.pinned || b.popularity - a.popularity || Date.parse(a.created) - Date.parse(b.created));
      break;
    case 'importance':
      array = array.filter(item => item.importance === 1);
      array.sort((a, b) => b.pinned - a.pinned || Date.parse(a.created) - Date.parse(b.created));
      break;
    case 'instructor':
      array = array.filter(item => item.is_instructor === true);
      array.sort((a, b) => b.pinned - a.pinned || Date.parse(a.created) - Date.parse(b.created));
      break;
    default:
      // Default order recent
      array.sort((a, b) => b.pinned - a.pinned || Date.parse(a.created) - Date.parse(b.created));
  }

  return array;
}